<template>
    <div>
        <input
                ref="input"
                id="upload"
                type="file"
                @change="onChange"
                :multiple="multiple"
        />

        <div @click="onClick">
            <slot />
            <div v-if="uploadType === 'image'" class="image-upload">
                <img v-if="imagePath" :src="imagePath" alt="图片" class="image" />
                <div v-else class="uploader">
                    <a-icon :type="loading ? 'loading' : 'plus'" />
                    <div class="text">上传</div>
                </div>
            </div>
        </div>
        <div v-if="showProgress" style="margin-top: 8px;">
            <div style="font-size: 12px; color: #666; margin-bottom: 4px;">{{ uploadFileName }}</div>
            <a-progress :percent="uploadProgress" :show-info="true" />
        </div>
    </div>
</template>

<script>
import { uploadOssFile } from "@/api/upload";
export default {
    props: {
        uploadType: {
            type: String,
            default: "file",
        },
        imagePath: {
            type: String,
            default: "",
        },
        // 是否可以多选
        multiple: {
            type: Boolean,
            default: true,
        },
        // 要上传的位置
        moduleName: {
            type: String,
            default: "project",
        },
    },

    data() {
        return {
            loading: false,
            uploadProgress: 0,
            uploadFileName: '',
        };
    },

    computed: {
        showProgress() {
            return this.uploadProgress > 0 && this.uploadProgress <= 100;
        },
    },

    methods: {
        onClick() {
            this.$refs.input.click();
        },

        formatFileSize(size) {
            return size / 1024 / 1024 > 0.1
                ? `(${(size / 1024 / 1024).toFixed(1)}M)`
                : `(${(size / 1024).toFixed(1)}KB)`;
        },

        onChange(e) {
            const files = e.target.files;
            const data = new FormData();
            for (let i = 0; i < files.length; i++) {
                data.append("files", files[i]);
                data.append("moduleName", this.moduleName);
            }

            this.loading = true;
            this.uploadProgress = 0;

            const names = Array.from(files).map(f =>
                f.name + this.formatFileSize(f.size)
            );
            this.uploadFileName = names.join('; ');

            uploadOssFile(data, (progressEvent) => {
                const pct = Number(
                    (progressEvent.loaded / progressEvent.total * 100).toFixed(2)
                );
                this.uploadProgress = Math.min(pct, 99);
            })
                .then((res) => {
                    this.uploadProgress = 100;
                    if (Array.isArray(res)) {
                        this.$emit(
                            "uploaded",
                            res.map((item) => {
                                return {
                                    id: item.id,
                                    name: item.name,
                                    completePath: item.completePath,
                                };
                            })
                        );
                    }
                })
                .finally(() => {
                    this.loading = false;
                    e.target.value = null;
                    setTimeout(() => { this.uploadProgress = 0; }, 1000);
                });
        },
    },
};
</script>

<style lang="less" scoped>
#upload {
  display: none;
}

.image-upload {
  cursor: pointer;
  .uploader {
    width: 128px;
    height: 128px;
    background-color: #f9f9f9;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    i {
      font-size: 32px;
      color: #999;
    }
    .text {
      color: #666;
    }
  }
}

.image {
  width: 128px;
  height: 128px;
}
</style>